import ApiService from '@/services/api.service';
import getters from '@/store/global';

const state = {
    friends: {},
    count: '',
    next: '',
    errors: {}
};

getters['fetchFriends'] = function(state) { return state.friends }
getters['fetchFriendsCount'] = function(state) { return state.count }
getters['fetchFriendsNext'] = function(state) { return state.next }

const actions = {
    profileGet(context, [id, query=false]) {
        let url = 'friends/' + id + '/';
        if (query) url += '?q=' + query;
        return ApiService
            .get(url)
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('SET_FRIENDS', response.data.results);
                context.commit('SET_COUNT', response.data.count);
                context.commit('SET_NEXT', response.data);
            })
            .catch(() => {
                throw new Error('Something goes wrong');
            });
    },
    get(context, payload=false) {
        let url =
            payload ?
            'friends/?q=' + payload :
            'friends/';
        return ApiService
            .get(url)
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('SET_FRIENDS', response.data.results);
                context.commit('SET_COUNT', response.data.count);
                context.commit('SET_NEXT', response.data);
            })
            .catch(() => {
                throw new Error('Something goes wrong');
            });
    },
    getNext(context) {
        return ApiService
            .get(context.state.next)
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('ADD_FRIENDS', response.data.results);
                context.commit('SET_COUNT', response.data.count);
                context.commit('SET_NEXT', response.data);
            })
            .catch((response) => {
                context.commit('SET_ERROR', response.data);
                throw new Error('Something goes wrong');
            });
    },
    remove(context, payload) {
        return ApiService
            .delete('friends/' + payload + '/remove/')
            .then((response) => {
                context.commit('REMOVE_FRIEND', payload);
                context.commit('SET_ERROR', {});
            })
            .catch(() => {
                throw new Error('Something goes wrong');
            });
    },
    clear(context) {
        context.commit('SET_FRIENDS', []);
    }
};

const mutations = {
    SET_FRIENDS(state, friends) {
        state.friends = friends;
        state.errors = {};
    },
    ADD_FRIENDS(state, friends) {
        state.friends = state.friends.concat(friends);
    },
    SET_NEXT(state, data) {
        let symbol = data.url.indexOf('?') == -1 ? '?' : '&';
        if (data.page < data.num_pages) {
            state.next =
            data.url +
            symbol +
            data.page_param +
            '=' +
            (data.page + 1);
        } else {
            state.next = '';
        }
    },
    REMOVE_FRIEND(state, friend) {
        for (let i in state.friends) {
            if (state.friends[i].id == friend) {
                state.friends.splice(i, 1);
            }
        }
        state.count = --state.count;
    },
    SET_COUNT(state, count) {
        state.count = count;
        state.errors = {};
    },
    SET_ERROR(state, errors) {
        state.errors = errors;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
